//
//
//
//
//
//
//
//
//
//
//
//
//
//
const SquareImage = () => import('~/components/atoms/Product/SquareImage.vue');

export default {
  name: 'ZoomableImage',
  components: {
    SquareImage
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isPanning: false,
      tapFirst: false,
      tapTimeout: null,
      scale: 1,
      clientX: 0,
      clientY: 0,
      diffX: 0,
      diffY: 0,
      height: 1,
      width: 1
    };
  },

  computed: {
    zoomStyle() {
      const rx = 100 * (this.diffX / this.width);
      const ry = 100 * (this.diffY / this.height);
      const limit = this.scale === 4 ? 150 : 50;
      const x = Math.min(Math.max(rx, -limit), limit);
      const y = Math.min(Math.max(ry, -limit), limit);
      return {
        transform: "translate(".concat(x, "%, ").concat(y, "%) scale(").concat(this.scale, ")")
      };
    }

  },
  watch: {
    index(newValue) {
      if (newValue) {
        this.resetZoom();
      }
    }

  },

  mounted() {
    const {
      offsetHeight,
      offsetWidth
    } = this.$refs.zoomable;
    this.height = offsetHeight;
    this.width = offsetWidth;
  },

  methods: {
    onTap() {
      // onTap function: differentiates tap from double tap
      if (!this.tapFirst) {
        this.tapFirst = true;
        this.tapTimeout = setTimeout(() => {
          this.tapFirst = false;
        }, 500);
      } else {
        this.tapFirst = false;
        this.tapTimeout = clearTimeout(this.tapTimeout);

        if (this.scale < 4) {
          this.scale *= 2;
        } else {
          this.resetZoom();
        }
      }
    },

    startMove(event) {
      if (this.scale !== 1) {
        event.stopPropagation();
        this.isPanning = true;
        this.disableWindowScroll();
        this.$emit('start-zoom-panning');
      }
    },

    moveZoom(event) {
      if (this.scale === 1) {
        return;
      }

      const [{
        clientX,
        clientY
      }] = event.changedTouches;
      const diffX = this.clientX && clientX - this.clientX;
      const diffY = this.clientY && clientY - this.clientY;
      this.clientX = clientX;
      this.clientY = clientY;
      this.diffX += diffX;
      this.diffY += diffY;
    },

    endMove(event) {
      if (this.isPanning) {
        event.stopPropagation();
        this.clientX = 0;
        this.clientY = 0;
        this.isPanning = false;
        this.enableWindowScroll();
        this.$emit('end-zoom-panning');
      }
    },

    resetZoom() {
      this.clientX = 0;
      this.clientY = 0;
      this.diffX = 0;
      this.diffY = 0;
      this.scale = 1;
    }

  }
};